import { Asset, isAssetProps } from "mibaby-frontend/media/Asset";
import { Dummy } from "mibaby-frontend/media/Image";

// @ts-check
/**
 * Image - Default Component that renders a image
 *
 * If image param is provided we do
 * 1. render a img if image is a string
 * 2. render a Asset if image is object and has the necessary props
 * 3. render a component if image is one
 * 4. return null if nothing else matched
 *
 * the used Asset can be overriden, using the `AssetComponent` prop
 *
 * @param {{
 *  image:
 *     string
 *   | import("mibaby-frontend/types").AssetProps
 *   | JSX.Element
 *  AssetComponent: (props: import("mibaby-frontend/types").AssetProps) => JSX.Element
 * }} param0
 * @return {JSX.Element}
 */
const Image = ({ image = null, AssetComponent = Asset }) =>
  image &&
  (isAssetProps(image) ? (
    <AssetComponent {...image} />
  ) : typeof image === "string" ? (
    <Dummy src={image} className="img-responsive" />
  ) : (
    React.isValidElement(image) && image
  ));

export default Image;
